export const ERROR_CODE = {
    RECURSION: '10001',
}

export class NotAuthorizedError extends Error {
    name = 'NotAuthorizedError';
}